
import { defineComponent } from "vue";
import Chip from "primevue/chip";

export default defineComponent({
  name: "PreSongCard",
  components: { Chip },
  props: {
    screenTitle: {
      type: String,
      default: "",
    },
    start: {
      type: Number,
      default: 0,
    },
    end: {
      type: Number,
      default: 0,
    },
    tags: {
      type: Array,
      default: () => [],
    },
    videoId: {
      type: String,
      default: "",
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    num2stamp(time: number) {
      const h = Math.floor(time / 3600);
      const m = Math.floor((time % 3600) / 60);
      const s = Math.floor(time % 60);
      const hs = ("00" + h).slice(-2);
      const ms = ("00" + m).slice(-2);
      const ss = ("00" + s).slice(-2);
      return hs + ":" + ms + ":" + ss;
    },
    rm() {
      this.$emit("remove", this.index);
    },
  },
  computed: {
    startStamp(): string {
      return this.num2stamp(this.start);
    },
    endStamp(): string {
      return this.num2stamp(this.end);
    },
  },
});
